const SET_OBS_DOWN_PAYMENT = 'SET_OBS_DOWN_PAYMENT';
const SET_OBS_TERM = 'SET_OBS_TERM';
const SET_OBS_CREDIT = 'SET_OBS_CREDIT';
const SET_SHOW_OBS = 'SET_SHOW_OBS';
const SET_OBS = 'SET_OBS';


export {
    SET_OBS_DOWN_PAYMENT,
    SET_OBS_TERM,
    SET_OBS_CREDIT,
    SET_SHOW_OBS,
    SET_OBS,
};



// WEBPACK FOOTER //
// ./src/containers/common/obs/constants.js